























import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class RedoOn extends Vue {
    @Prop() private userConfigColor! : string;
}
